import { VendorPage } from '../VendorPage';

export const VendorPunchlistsPage = () => {
  return <VendorPage isPunchlistPage />;
};
